import {
  CaAnPage,
  DangKyCaAnPage,
  DangKyHocSinhPage,
  DiemDanhAnPage,
  DotDangKyAnPage,
  HomePage,
  XacNhanAnHocSinhPage,
  BaoCaoDiemDanhPage,
  CauHinhDonGiaPage,
  DanhSachCongNoPage,
  DonTraPage
} from './pages';
import BaoCaoNgayPage from './pages/bao-cao/bao-cao-ngay';
import BaoCaoThangPage from './pages/bao-cao/bao-cao-thang';
import ThucDonPage from './pages/thuc-don/danh-sach-thuc-don';
import NgayNghiPage from './pages/danh-muc/ngay-nghi';
import TrangThaiDangKyAnPage from './pages/danh-muc/trang-thai-dang-ky-an';



const routes = [
  {
    path: "/home/:tab?",
    component: HomePage,
  },
  {
    path: "/food/thucdon",
    component: ThucDonPage,
  },
  {
    path: "food/ca-an",
    component: CaAnPage,
  },
  {
    path: "food/ca-an-truong",
    component: DangKyCaAnPage,
  },
  {
    path: "food/dot-dang-ky-an",
    component: DotDangKyAnPage,
  },
  {
    path: "food/dang-ky-hoc-sinh",
    component: DangKyHocSinhPage,
  },
  {
    path: "food/xac-nhan-an-hoc-sinh",
    component: XacNhanAnHocSinhPage,
  },
  {
    path: "food/diem-danh-an",
    component: DiemDanhAnPage,
  },
  {
    path: "food/bao-cao/ngay",
    component: BaoCaoNgayPage,
  },
  {
    path: "food/bao-cao/thang",
    component: BaoCaoThangPage,
  },
  {
    path: "food/bao-cao/diem-danh",
    component: BaoCaoDiemDanhPage,
  },
  {
    path: "food/don-gia-ban-tru",
    component: CauHinhDonGiaPage,
  },
  {
    path: "food/cong-no",
    component: DanhSachCongNoPage,
  },
  {
    path: "danh-muc/ngay-nghi",
    component: NgayNghiPage,
  },
  {
    path: "danh-muc/trang-thai-dang-ky-an",
    component: TrangThaiDangKyAnPage,
  },
  {
    path: "food/don-tra",
    component: DonTraPage,
  },
  {
    path: "danh-muc/don-tra",
    component: DonTraPage,
  },
  //   {
  //   path: "/face-id/:tab?",
  //   component: Faceid,
  // },
];

export default routes.map((route) => {
  return {
    ...route,
  };
});
